module.exports = __webpack_public_path__ + "img/ic_folder.1bbe793a.svg";